import { API, graphqlOperation } from "aws-amplify";
import { GET_SKILL_OUTCOME_SUMMARY, GET_SKILL_OUTCOME_SUMMARY_SUCCESS, GET_SKILL_OUTCOME_SUMMARY_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetLearnerProgressDetails } from "./../../queries";

const getSkillOutcome = (userId: string, productId :number) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_SKILL_OUTCOME_SUMMARY });
    if (sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/skillOutcomeSummary.json");
      dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS, payload: { ...dummyData } });
    } else {
      const getProgressDetails = API.graphql(graphqlOperation(GetLearnerProgressDetails(userId.toString(), productId, 'learnerOutcomeDetails'))) as Promise<any>;
      getProgressDetails.then(async (progressDetails: any) => {
        let response = JSON.parse(progressDetails.data.getProgressDetails);
        if (response.statusCode === 200) {
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS, payload: { ...response } });
        } else {
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      })
        .catch((err: any) => {
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        });
    }
  };
};

export default {
  getSkillOutcome,
};
